export default __webpack_public_path__ + "static/media/08.8ce0a8f2.jpg";